import LoginPage from '@/components/pages/Homepage/Login'
import VerifyPage from '@/components/pages/Homepage/Verify'
import ForgotPasswordPage from '@/components/pages/Homepage/ForgotPassword'
import ResetPasswordPage from '@/components/pages/Homepage/ResetPassword'
import ConfirmChangeEmailPage from '@/components/pages/Homepage/ConfirmChangeEmail'

export default [
  {
    path: '/',
    component: LoginPage
  },
  {
    path: '/login',
    component: LoginPage
  },
  {
    path: '/verify/:token',
    component: VerifyPage
  },
  {
    path: '/forgot-password',
    component: ForgotPasswordPage
  },
  {
    path: '/forgot-password/:token',
    component: ResetPasswordPage
  },
  {
    path: '/email-change/:token',
    component: ConfirmChangeEmailPage
  }
]



// WEBPACK FOOTER //
// ./src/router/homepageRoutes.js